export default __webpack_public_path__ + "static/media/IMG_5561.d92935f3.jpg";